import Glide, { Controls, Breakpoints, Swipe  } from '@glidejs/glide/dist/glide.modular.esm'

export default function(dom, opts) {
	let options = {
		...opts
	}
	let glide = null
	let glideOpts = {
		gap: 0,
	}

	init()


	function init() {
		generateBullets(
			dom.querySelector('.glide__bullets'),
			dom.querySelector('[data-glide-el="track"]').querySelectorAll(".ce_image")
		)
		glide = new Glide(dom, glideOpts).mount({Controls, Breakpoints, Swipe})
	}

	function generateBullets(container, images) {
		images.forEach((el, i) => {
			container.appendChild(createBullet({}, i))
		})
	}

	function createBullet(data, index) {
		let el = document.createElement('div')
		el.innerHTML = `<button class="glide__bullet" data-glide-dir="=${index}"></button>`
		return el.firstChild
	}


}
